import React, { useContext, useEffect, useState } from "react";
/// React router dom
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../../images/only-logo.png";
import logo2 from "../../../images/logo-inline.png";
import { toggleMenu } from "../../../store/slices/sidebar";

const Hamburger = () => {
  const { openMenuToggle } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const sideMenu = useSelector((state) => state.sideMenu);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1023);
  const [toggleLogo, setToggleLogo] = useState(true);

  useEffect(() => {
    setIsDesktop(window.innerWidth > 1023);
  }, [window.innerWidth]);

  const handleToggle = () => {
    setToggleLogo(prev => !prev)
    dispatch(toggleMenu());
  };
  
  //logic to determine which logo to show
  const showLogo = (isDesktop || sideMenu) && toggleLogo;

  return (
    <div className="nav-header">
      <Link
        to="/dashboard"
        className="brand-logo d-flex align-items-center justify-content-center"
      >
        <div className="logo-container">
          {showLogo ? (
            <img
              src={logo2}
              alt="nkenne-logo"
              className="logo-img-expanded logo-abbr"
              style={{
                maxWidth: "150px",
                height: "auto",
                transition: "all 0.1s ease",
              }}
            />
          ) : (
            <img
              src={logo}
              alt="nkenne-logo"
              className="logo-img logo-abbr"
              style={{
                maxWidth: "45px",
                height: "auto",
                transition: "all 0.1s ease",
              }}
            />
          )}
        </div>
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          handleToggle();
          openMenuToggle();
        }}
      >
        <div className={`hamburger ${sideMenu ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="22"
              y="11"
              width="4"
              height="4"
              rx="2"
              fill="#2A353A"
            />
            <rect
              x="11"
              width="4"
              height="4"
              rx="2"
              fill="#2A353A"
            />
            <rect
              x="22"
              width="4"
              height="4"
              rx="2"
              fill="#2A353A"
            />
            <rect
              x="11"
              y="11"
              width="4"
              height="4"
              rx="2"
              fill="#2A353A"
            />
            <rect
              x="11"
              y="22"
              width="4"
              height="4"
              rx="2"
              fill="#2A353A"
            />
            <rect
              width="4"
              height="4"
              rx="2"
              fill="#2A353A"
            />
            <rect
              y="11"
              width="4"
              height="4"
              rx="2"
              fill="#2A353A"
            />
            <rect
              x="22"
              y="22"
              width="4"
              height="4"
              rx="2"
              fill="#2A353A"
            />
            <rect
              y="22"
              width="4"
              height="4"
              rx="2"
              fill="#2A353A"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Hamburger;
